if (!customElements.get('sr-fall-sale')) {
  customElements.define('sr-fall-sale', class extends HTMLElement {
    connectedCallback() {
      this.endsAt = Date.parse(this.dataset.end);
      if (!Number.isFinite(this.endsAt)) { this.hidden = true; return; }
      this.updateClock();
      if (!this.hidden) this.interval = setInterval(() => this.updateClock(), 1000);
    }
    disconnectedCallback() { clearInterval(this.interval); }
    updateClock() {
      const remaining = this.endsAt - Date.now();
      if (remaining <= 0) { this.hidden = true; clearInterval(this.interval); return; }
      const seconds = Math.floor(remaining / 1000);
      const values = { days: Math.floor(seconds / 86400), hours: Math.floor(seconds / 3600) % 24, minutes: Math.floor(seconds / 60) % 60, seconds: seconds % 60 };
      for (const [unit, value] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(value).padStart(2, '0');
      this.querySelector('[role="timer"]').hidden = false;
    }
  });
}
